export const environment = {
  production: true,
  root: `${window.location.protocol}//${window.location.host}/admin-api/`,
  wsEndpoint: `${window.location.protocol.replace("http", "ws")}//${window.location.host}/admin-api/graphql`,
  operatorDashboardSmoothMarkersEnabled: true,
  operatorDashboardMarkerAnimationMinMs: 500,
  operatorDashboardMarkerAnimationNormalMs: 1000,
  operatorDashboardMarkerAnimationMaxMs: 1600,
  operatorDashboardLargeJumpMeters: 2000,
  operatorDashboardFastBootstrapEnabled: true,
  operatorDashboardLocationMergeGuardEnabled: true,
  operatorDashboardPerformanceDebug: false,
  adminDesktopAlertsForegroundEnabled: true,
};
